import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CreateNegotiation from '../../CreateNegotiation';

class CreateNegotiationModal extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };
  render() {
    const { className, modalData } = this.props;
    const classList = classNames('create-negotiation-modal', className);
    return <CreateNegotiation className={classList} data={modalData} />;
  }
}

export default CreateNegotiationModal;
